var _path, _mask, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnsub1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 288,
    viewBox: "0 0 320 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M176.451 288C255.731 288 320 223.731 320 144.451C320 65.1711 255.731 0.901978 176.451 0.901978C97.1714 0.901978 32.9023 65.1711 32.9023 144.451C32.9023 223.731 97.1714 288 176.451 288Z",
    fill: "#8F95AC"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 0,
    width: 289,
    height: 288
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.451 288C255.731 288 320 223.731 320 144.451C320 65.1711 255.731 0.901978 176.451 0.901978C97.1714 0.901978 32.9023 65.1711 32.9023 144.451C32.9023 223.731 97.1714 288 176.451 288Z",
    fill: "#8F95AC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.034 173.853H97.3613V225.237H108.034V173.853Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.439 126.569H80.6103C68.2415 126.569 58.2051 136.606 58.2051 148.974V178.165H116.939",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.439 126.569H80.6103C68.2415 126.569 58.2051 136.606 58.2051 148.974V178.165H116.939",
    stroke: "#22292E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.104 178.165V148.974C108.104 136.606 118.14 126.569 130.509 126.569C142.878 126.569 152.914 136.606 152.914 148.974V178.165",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.104 178.165V148.974C108.104 136.606 118.14 126.569 130.509 126.569C142.878 126.569 152.914 136.606 152.914 148.974V178.165",
    stroke: "#22292E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.801 178.165V149.257C109.801 137.807 119.06 128.619 130.439 128.619C141.818 128.619 151.077 137.878 151.077 149.257V178.165",
    stroke: "#22292E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.801 174.631H180.48C181.469 174.631 182.247 175.408 182.247 176.398C182.247 177.387 181.469 178.165 180.48 178.165H103.793",
    stroke: "#22292E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8505 145.158C74.388 145.158 76.4451 143.101 76.4451 140.564C76.4451 138.026 74.388 135.969 71.8505 135.969C69.3129 135.969 67.2559 138.026 67.2559 140.564C67.2559 143.101 69.3129 145.158 71.8505 145.158Z",
    stroke: "#22292E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8501 143.404C73.4187 143.404 74.6904 142.132 74.6904 140.564C74.6904 138.995 73.4187 137.723 71.8501 137.723C70.2814 137.723 69.0098 138.995 69.0098 140.564C69.0098 142.132 70.2814 143.404 71.8501 143.404Z",
    stroke: "#22292E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7747 141.341C71.2092 141.341 70.7852 140.917 70.7852 140.352V110.737C70.7852 110.172 71.2092 109.748 71.7747 109.748H71.8453C72.4108 109.748 72.8348 110.172 72.8348 110.737V140.352C72.6935 140.917 72.2694 141.341 71.7747 141.341Z",
    fill: "white",
    stroke: "#22292E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6875 111.797H73.4008V97.1124H49.6875L55.1263 104.509L49.6875 111.797Z",
    fill: "#FF2D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.978 174.631H128.176C127.115 174.631 126.338 173.783 126.338 172.793V150.459C126.338 149.399 127.186 148.621 128.176 148.621H166.978C168.038 148.621 168.816 149.469 168.816 150.459V172.793C168.816 173.853 167.968 174.631 166.978 174.631Z",
    fill: "white",
    stroke: "#22292E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.178 149.964L146.413 164.948C146.413 164.948 148.039 166.291 149.876 164.948L166.839 149.964",
    stroke: "#22292E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3594 178.165V320.512",
    stroke: "#22292E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.914 178.165V320.512",
    stroke: "#22292E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.104 178.165V320.512",
    stroke: "#22292E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.904 121.763C234.904 121.763 228.119 123.671 227.129 124.307C226.564 124.661 220.273 129.891 214.477 134.415C209.389 138.373 204.724 141.624 204.724 141.624L188.114 120.632L179.35 108.829L177.512 105.507L175.321 101.902L166.628 95.5411L166.274 96.5306L166.557 97.9442L167.759 99.3578L169.172 100.842L169.526 101.69V102.326L168.607 102.256L165.921 100.559L163.235 98.2269L161.61 91.7244L160.903 91.8658L160.125 92.926L160.055 95.1877L160.62 101.619L161.186 102.68L163.589 104.941L167.617 107.557L173.625 111.868L191.648 146.713L198.504 157.668C198.504 157.668 200.483 161.061 205.148 158.163C209.813 155.194 226.634 149.116 226.634 149.116L228.825 163.252L234.056 205.659L274.413 194.35L281.552 172.935L295.546 189.615L299.01 173.712L292.79 141.553L282.541 124.025L271.586 117.381L260.631 115.614L234.904 121.763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.292 85.9995C225.292 85.9995 223.737 92.9967 226.988 100.347C230.168 107.698 231.935 111.656 233.349 111.444C234.692 111.232 239.145 109.465 239.145 109.465C239.145 109.465 240.346 112.504 240.346 114.978C240.346 117.452 240.7 119.219 236.317 121.198C231.935 123.177 228.543 127.7 228.543 127.7L224.938 134.839L241.548 136.182L261.479 135.828L264.66 127.347L263.6 112.999L250.029 91.5124L238.579 87.413L225.292 85.9995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.443 88.968C224.443 88.968 229.179 93.8448 238.579 93.4207C247.909 92.9967 248.969 102.468 248.969 106.214C248.969 109.96 250.453 117.24 263.811 120.491C277.17 123.742 278.937 122.753 282.4 128.972C285.793 135.192 292.931 161.061 294.415 169.966C295.9 178.872 296.041 187.777 294.415 189.756C292.79 191.665 274.767 176.398 272.01 169.966C272.01 169.966 270.597 185.233 275.968 198.732C275.968 198.732 279.432 201.772 288.549 197.177C297.596 192.583 305.653 181.699 306.502 166.291C307.35 150.883 303.109 135.828 287.065 123.035C271.021 110.242 263.175 115.755 261.832 96.3186C260.49 76.8819 246.99 72.8532 238.084 74.1961C229.037 75.4683 223.524 83.0309 224.443 88.968Z",
    fill: "#2C2E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.669 104.729C243.669 104.729 240.417 110.666 233.279 111.373C231.512 111.515 224.727 99.1457 224.727 87.9078",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.073 109.394C239.073 109.394 241.335 116.038 239.851 118.794C238.367 121.551 228.26 123.671 228.26 123.671C228.26 123.671 224.089 125.933 220.202 129.538C215.679 133.778 204.653 141.624 204.653 141.624C204.653 141.624 182.106 113.282 179.35 108.829C176.593 104.376 176.523 102.538 173.413 100.135C170.303 97.8028 166.627 95.5411 166.627 95.5411C166.627 95.5411 165.285 97.2374 167.758 99.3578C170.161 101.478 169.949 102.68 168.889 102.397C167.758 102.114 163.73 99.075 163.235 98.2269C162.74 97.4494 161.609 91.7244 161.609 91.7244C161.609 91.7244 159.701 91.4417 159.984 94.7636C160.266 98.0855 160.478 100.559 160.62 101.549C160.69 102.538 163.235 104.659 164.083 105.224C164.861 105.719 172.777 110.666 173.695 111.797C174.614 112.928 187.619 141.977 198.998 158.092C198.998 158.092 200.907 160.283 203.946 158.728C208.611 156.254 226.775 149.045 226.775 149.045",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.654 141.624C204.654 141.624 202.109 150.953 203.876 158.799",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.877 124.095C277.877 124.095 249.464 132.294 228.189 123.671",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.705 149.116C226.705 149.116 233.844 194.421 234.126 205.659C234.126 205.659 251.655 214.282 279.078 204.952C279.078 204.952 275.615 200.287 273.919 190.604",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.705 149.116C226.705 149.116 233.844 194.421 234.126 205.659C234.126 205.659 251.655 214.282 279.078 204.952C279.078 204.952 275.615 200.287 273.919 190.604",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.007 204.881C279.007 204.881 286.711 215.978 286.994 229.124C287.277 242.271 277.665 287.717 277.594 291.605C277.523 295.492 283.389 307.013 284.874 310.405C284.874 310.405 253.846 328.004 228.331 330.549C228.331 330.549 228.119 294.361 228.331 276.974C228.543 259.587 229.532 218.593 234.056 205.588C234.056 205.588 255.259 213.928 279.007 204.881Z",
    fill: "#2C2E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.239 118.158C257.239 118.158 247.838 124.378 239.852 118.795",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.929 123.035C246.475 123.035 246.918 122.276 246.918 121.339C246.918 120.402 246.475 119.643 245.929 119.643C245.382 119.643 244.939 120.402 244.939 121.339C244.939 122.276 245.382 123.035 245.929 123.035Z",
    fill: "white",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.778 176.398C289.043 161.909 264.8 133.001 259.499 133.001C255.4 133.001 238.79 132.86 238.79 132.86C238.437 133.92 238.719 134.556 239.921 135.051C239.921 135.051 239.426 136.323 240.84 136.747C240.84 136.747 240.416 137.878 241.829 138.231C246.423 139.291 257.449 140.705 258.368 141.341C263.174 144.663 273.423 173.995 276.886 180.285C281.41 188.696 291.87 193.361 293.92 190.816C297.736 186.081 293.778 176.398 293.778 176.398Z",
    fill: "white",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.77 136.818C240.77 136.818 248.332 137.312 252.078 137.807",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.922 135.051C239.922 135.051 250.453 135.192 252.997 135.404",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.685 285.243C137.685 285.243 151.82 245.027 134.999 227.782C118.177 210.536 92.5208 217.18 82.8377 210.112C73.1547 203.044 85.9476 172.511 80.6467 163.676C75.3458 154.841 60.2912 152.155 50.6081 147.773C40.9251 143.391 37.8152 129.679 31.1714 122.116C24.5276 114.554 11.3106 110.172 11.3106 123.883C11.3106 137.595 24.5983 144.663 8.62482 161.909C-7.34863 179.154 1.981 181.769 11.7347 186.646C21.4884 191.523 38.7341 195.905 25.4464 210.112C12.1588 224.318 9.89704 226.439 20.4989 238.807C31.1007 251.176 36.8257 249.409 28.4856 260.506C20.0748 271.532 40.4304 284.395 53.718 285.243H137.685Z",
    fill: "#FF2D23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.342 285.243C163.318 261.495 179.998 231.103 210.956 202.902",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M183.885 232.376C183.885 232.376 185.51 219.159 184.874 209.546",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.092 251.106C171.092 251.106 172.505 241.988 171.587 232.517",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190.389 224.248C190.389 224.248 201.768 220.007 209.755 220.784",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175.545 244.108C175.545 244.108 184.875 239.868 193.427 240.857",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M159.784 272.309C159.784 272.309 161.056 256.406 155.119 246.653",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M157.238 278.034C157.238 278.034 168.194 272.027 177.24 274.43",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M195.052 218.098C197.902 218.098 200.212 215.788 200.212 212.939C200.212 210.089 197.902 207.779 195.052 207.779C192.203 207.779 189.893 210.089 189.893 212.939C189.893 215.788 192.203 218.098 195.052 218.098Z",
    fill: "#22292E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M212.792 226.58C215.642 226.58 217.952 224.27 217.952 221.42C217.952 218.571 215.642 216.261 212.792 216.261C209.943 216.261 207.633 218.571 207.633 221.42C207.633 224.27 209.943 226.58 212.792 226.58Z",
    fill: "#22292E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M181.199 280.649C184.048 280.649 186.358 278.339 186.358 275.49C186.358 272.64 184.048 270.33 181.199 270.33C178.349 270.33 176.039 272.64 176.039 275.49C176.039 278.339 178.349 280.649 181.199 280.649Z",
    fill: "#22292E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M153.21 248.985C156.06 248.985 158.37 246.675 158.37 243.826C158.37 240.976 156.06 238.666 153.21 238.666C150.361 238.666 148.051 240.976 148.051 243.826C148.051 246.675 150.361 248.985 153.21 248.985Z",
    fill: "#22292E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M183.884 220.926C185.875 220.926 187.489 219.312 187.489 217.321C187.489 215.33 185.875 213.716 183.884 213.716C181.893 213.716 180.279 215.33 180.279 217.321C180.279 219.312 181.893 220.926 183.884 220.926Z",
    fill: "#22292E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M165.509 259.87C167.5 259.87 169.114 258.256 169.114 256.265C169.114 254.274 167.5 252.661 165.509 252.661C163.518 252.661 161.904 254.274 161.904 256.265C161.904 258.256 163.518 259.87 165.509 259.87Z",
    fill: "#22292E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M199.718 228.912C201.709 228.912 203.323 227.299 203.323 225.308C203.323 223.317 201.709 221.703 199.718 221.703C197.727 221.703 196.113 223.317 196.113 225.308C196.113 227.299 197.727 228.912 199.718 228.912Z",
    fill: "#22292E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M178.019 249.763C180.868 249.763 183.178 247.453 183.178 244.603C183.178 241.754 180.868 239.444 178.019 239.444C175.169 239.444 172.859 241.754 172.859 244.603C172.859 247.453 175.169 249.763 178.019 249.763Z",
    fill: "#22292E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M184.24 210.819C187.089 210.819 189.399 208.509 189.399 205.659C189.399 202.809 187.089 200.499 184.24 200.499C181.39 200.499 179.08 202.809 179.08 205.659C179.08 208.509 181.39 210.819 184.24 210.819Z",
    fill: "#22292E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M170.951 234.143C173.8 234.143 176.11 231.833 176.11 228.983C176.11 226.134 173.8 223.823 170.951 223.823C168.101 223.823 165.791 226.134 165.791 228.983C165.791 231.833 168.101 234.143 170.951 234.143Z",
    fill: "#22292E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M197.314 246.229C200.163 246.229 202.473 243.919 202.473 241.069C202.473 238.22 200.163 235.91 197.314 235.91C194.464 235.91 192.154 238.22 192.154 241.069C192.154 243.919 194.464 246.229 197.314 246.229Z",
    fill: "#22292E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M212.792 205.235C215.642 205.235 217.952 202.925 217.952 200.075C217.952 197.226 215.642 194.916 212.792 194.916C209.943 194.916 207.633 197.226 207.633 200.075C207.633 202.925 209.943 205.235 212.792 205.235Z",
    fill: "#22292E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6309 285.244C95.6309 285.244 55.9093 194.562 32.7266 160.99",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsub1);
export default __webpack_public_path__ + "static/media/unsub-1.10aedadf.svg";
export { ForwardRef as ReactComponent };